<app-tab-navigation-header title="All Devices" i18n-title="@@deviceMainTab-devicesTitle">
	<mat-tab-group appQueryStringTabGroup>
		<mat-tab label="All Devices" i18n-label="@@deviceMainTab-allLabel" data-automation-id="all-devices-tab">
			<ng-template matTabContent>
				<app-all-devices
					[isUnitTesting]="isUnitTesting"
					[appBreadcrumbLabel]="allDevicesBreadcrumbLabel"
				></app-all-devices>
			</ng-template>
		</mat-tab>

		<mat-tab label="Device Groups" i18n-label="@@deviceMainTab-groupsLabel" data-automation-id="device-groups-tab">
			<ng-template matTabContent>
				<app-device-groups [appBreadcrumbLabel]="deviceGroupsBreadcrumbLabel"></app-device-groups>
			</ng-template>
		</mat-tab>

		@if (isOracle) {
			<mat-tab label="Device Lookup" i18n-label="@@device-detailsDeviceLookup" data-automation-id="device-lookup-tab">
				<ng-template matTabContent>
					<app-device-lookup [appBreadcrumbLabel]="deviceLookupBreadcrumbLabel"></app-device-lookup>
				</ng-template>
			</mat-tab>
		}

		@if (hasDeviceManagementCapability && isSentriKeyAccessUser) {
			<mat-tab label="Migrate Devices" i18n-label="@@device-detailsMigrateDevice" data-automation-id="add-device-tab">
				<ng-template matTabContent>
					<app-migrate-devices-tab [appBreadcrumbLabel]="addDeviceBreadcrumbLabel"></app-migrate-devices-tab>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
